function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{font-family:'PublicSans-Light';}\n\t.st1{font-size:13px;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.3,14.7L13.9,1.8c-0.6-1.1-1.8-1.8-3-1.8c0,0,0,0,0,0C9.6,0,8.4,0.7,7.8,1.8C7.7,2,6.9,3.4,6,4.9C0.3,14.8-0.2,16,0,16.6 l0,0c0.1,1.9,1.6,3.3,3.5,3.3h14.7c0,0,0,0,0.1,0c1.2,0,2.3-0.7,3-1.8C21.9,17,21.9,15.7,21.3,14.7z M20.4,17.7 c-0.5,0.8-1.2,1.3-2.1,1.3H3.5c-1.4,0-2.5-1.1-2.5-2.5v-0.3c0.5-1.4,4.1-7.6,5.9-10.7C8.3,3,8.7,2.3,8.7,2.2C9.1,1.5,9.9,1,10.9,1 c0,0,0,0,0,0c0.9,0,1.8,0.5,2.2,1.2l7.4,12.9C20.9,15.9,20.8,16.9,20.4,17.7z"
});

var _ref4 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 9.3848 16.4102)",
  className: "st0 st1"
}, "!");

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.7 19.9",
    style: {
      enableBackground: "new 0 0 21.7 19.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.5b6d946d.svg";
export { ForwardRef as ReactComponent };